/**
 * 上传配置文件
 * 管理各种上传接口的超时时间和配置
 */

const uploadConfig = {
  // 默认超时时间配置（毫秒）
  timeout: {
    // 图片上传超时时间
    image: 60000, // 1分钟
    // 视频上传超时时间
    video: 300000, // 5分钟
    // 文件上传超时时间
    file: 120000, // 2分钟
    // 默认超时时间
    default: 60000 // 1分钟
  },

  // 文件大小限制（字节）
  maxSize: {
    image: 5 * 1024 * 1024, // 5MB
    video: 500 * 1024 * 1024, // 500MB
    file: 100 * 1024 * 1024 // 100MB
  },

  // 支持的文件类型
  acceptTypes: {
    image: '.jpg,.jpeg,.png,.gif',
    video: '.mp4,.avi,.mov,.rmvb,.rm',
    file: '.pdf,.doc,.docx,.xls,.xlsx,.txt'
  },

  // 获取超时时间
  getTimeout (type = 'default') {
    return this.timeout[type] || this.timeout.default
  },

  // 获取文件大小限制
  getMaxSize (type = 'default') {
    return this.maxSize[type] || this.maxSize.file
  },

  // 获取支持的文件类型
  getAcceptTypes (type = 'default') {
    return this.acceptTypes[type] || this.acceptTypes.file
  }
}

export default uploadConfig 